<template>
    <ScreenLayout ref="screenLayout" :rightVisible="true">
        <template slot="left">
            <ElementMenu :root="settingsElement" :activeKey="activeMenuKey" @click="elementMenuClicked" />
        </template>

        <AutomaticScroll @change="scrolled" scrolling-element-id="middle-column" :active-section-key="activeMenuKey" section-element-class="section-title">
            <ElementControl :element="activeElement" />
        </AutomaticScroll>

    </ScreenLayout>
</template>

<script>
import LayoutContainer2 from '@/ui-elements/LayoutContainer2'
import SectionLayout from '@/screens/SectionLayout'
import ElementControl from '@/screens/ElementControl'
import ElementLayout from '@/screens/ElementLayout'
import LayoutReadOnly from '@/ui-elements/LayoutReadOnly'
import ElementMenu from '@/screens/ElementMenu'
import ScrollHelpers from '../helpers/ScrollHelpers'
import ScreenLayout from '../screens/ScreenLayout'
import PageLayout from '../screens/PageLayout'
import AutomaticScroll from '@/ui-elements/AutomaticScroll'

export default {
    data() {
        return {

            autoScrolling: false,

            activeMenuKey: '111',

            activeElement: null,

            settingsElement: {
                title: 'Settings',
                type: 'Group',
              
                elements: [
                    {
                        title: 'Templates',
                        percent: 100,
                        type: 'Group',
                                        hideTitle: true,
                flat: true,  
                        elements: [
                            {
                                key: '111',
                                type: 'Group',
                                title: 'Email Templates',
                                complete: true,
                                elements: [
                                    {
                                        key:'32422',
                                        title: 'Signature',
                                        type: 'Text',
                                    }

                                ]
                                
                            },
                            {
                                key: '222',
                                title: 'SMS Templates',
                                type: 'Group',
                                complete: false,
                            },
                        ] 
                    },
                    {
                        title: 'Communication',
                        percent: 35,
                        type: 'Group',
                        hideTitle: true,
                        flat: true,
                        elements: [
                            {
                                key: '333',
                                type: 'Group',
                                title: 'Email Preferences',
                                complete: false,
                                elements: [
                                    {
                                        key: 83838,
                                        type: 'Text',
                                        title: 'CC on emails'
                                    },
                                    {
                                        key: 83839,
                                        type: 'Text',
                                        title: 'BCC on emails'
                                    },
                                    {
                                        key: 83840,
                                        type: 'Html',
                                        title: 'Email Signature'
                                    },
                                ]
                            },
                            {
                                key: '335',
                                type: 'Group',
                                title: 'SMS Preferences',
                                complete: false,
                                elements: [
                                    {
                                        key: 83838,
                                        type: 'Text',
                                        title: 'SMS Prefix'
                                    },
                                    {
                                        key: 83839,
                                        type: 'Text',
                                        title: 'SMS Suffix'
                                    },
                                ]
                            },
                            {
                                key: '383',
                                type: 'Group',
                                title: 'Phone Preferences',
                                complete: false,
                                elements: [
                                    {
                                        key: 83838,
                                        type: 'Text',
                                        title: 'CC on emails'
                                    },
                                    {
                                        key: 83839,
                                        type: 'Text',
                                        title: 'BCC on emails'
                                    },
                                ]
                            },
                            {
                                key: '385',
                                type: 'Group',
                                title: 'Other Communication Preferences',
                                complete: false,
                                elements: [
                                    {
                                        key: 83838,
                                        type: 'Text',
                                        title: 'SMS Prefix'
                                    },
                                    {
                                        key: 83839,
                                        type: 'Text',
                                        title: 'SMS Suffix'
                                    },
                                ]
                            },
             
                        ] 
                    },
                    {
                        title: 'Layout',
                        percent: 0,
                        type: 'Group',
                        elements: [
                            {
                                key: '555',
                                type: 'Text',
                                title: 'This item',
                                complete: false,
                            },
                            {
                                key: '666',
                                type: 'Text',
                                title: 'That item',
                                complete: false,
                            },
                        ] 
                    },
                    {
                        title: 'Maintenance',
                        percent: 0,
                        flat:true,
                        hideTitle: true,
                        type: 'Group',
                        elements: [
                            {
                                key: '273',
                                title: 'Copy Element Attribute',
                                percent: 0,
                                type: 'Group',
                                record: {
                                    element_name: 'Franky'
                                },
                                elements: [
                                    {
                                        key: '555',
                                        name: 'element_name',
                                        type: 'Text',
                                        title: 'Element Name',
                                        complete: false,
                                    },
                                    {
                                        key: '666',
                                        type: 'Text',
                                        name: 'attribute_name',
                                        title: 'Attribute to Change',
                                        complete: false,
                                    },
                                    {
                                        key: '668',
                                        type: 'Options',
                                        name: 'source',
                                        title: 'Value Source',
                                        options: [
                                            {value: 'master', text: 'Get from master file'},
                                            {value: 'manual', text: 'Enter a value manually'},
                                        ]
                                    },
                                    {   
                                        key: '671',
                                        type: 'Text',
                                        name: 'attribute_value',
                                        title: 'New Value',
                                        visible: '[source] == "manual"',
                                    },                                    
                                    {
                                        key: '689',
                                        type: 'Button',
                                        name: 'run_copy_element_attribute',
                                        title: 'Run Now',
                                        complete: false,
                                    },
                                ] 
                            },
                        ]
                    }
                ]
            }
        
        }
    },

    components: {
        ScreenLayout,
        PageLayout,
        LayoutContainer2,
        SectionLayout,
        ElementLayout,
        LayoutReadOnly,
        ElementMenu,
        ElementControl,
        AutomaticScroll,
    },
    
    props: {
        // item: Object,
    },

    computed: {
        // middleColumnElement() {
        //     return this.$refs.screenLayout.$refs.middleColumn
        // }
    },

    methods: {

        scrolled(key) {
            this.activeMenuKey = key
        },

        elementMenuClicked(item, section) {
            this.activeMenuKey = (section ? section.key : item.key)
            this.activeElement = item
        },
    },

    mounted() {
    
    }

}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// LayoutPage2.vue?395a7777